/* eslint-disable no-debugger */
import { MutationTree } from 'vuex';
import IWalmartCheckoutLocation from './models/Location';
import { IWalmartCheckoutState } from './state';
import { MUT_SEND_TELEMTRY, MUT_SET_LOCATION } from './types';

const mutations: MutationTree<IWalmartCheckoutState> = {
    [MUT_SET_LOCATION](state, location: IWalmartCheckoutLocation) {
        state.location = location;
    },
    [MUT_SEND_TELEMTRY](state) {
        state.telemtry = true;
    },
};

export default mutations;
